import script from "./grid-widget.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-widget.vue?vue&type=script&setup=true&lang=js"

import "./grid-widget.vue?vue&type=style&index=0&id=5892f83a&lang=scss&scoped=true"

import exportComponent from "D:\\code\\form_designer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5892f83a"]])

export default __exports__